function Footer() {
  const today=new Date();
    return (
      <footer className='footer'>
        <p>Developed and maintained by YROS SOFTWARE {today.getFullYear()}. </p>
      </footer>
    )
  }
  
  export default Footer